<div class="mam-actions-cell" *ngIf="params?.data">
  <button class="mam-actions-cell__btn" title="Edit" (click)="onEdit()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="currentColor" />
    </svg>
  </button>
  <button class="mam-actions-cell__btn" title="Play" (click)="onPlay()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M8 5v14l11-7z" fill="currentColor" />
    </svg>
  </button>
  <button class="mam-actions-cell__btn" title="Download" (click)="onDownload()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="currentColor" />
    </svg>
  </button>
</div>
